import React, { useState, useEffect } from 'react';
import { Table } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { semesterLabel } from '../../../../../../const/semesterLabel';

const { table } = courseStruct;

export const Course = ({ courses, semesterName, updateSemester, apaPoint, status }) => {

  const [_courses, setCourses] = useState(courses?.length > 0 ? courses : []);
  const handleCourses = (courses) => setCourses(courses);

  const handleSave = (row) => {
    const currentCourses = [..._courses];
    const index = currentCourses.findIndex((item) => item.key === row.key);


    if (index === -1) {
      return;
    }

    currentCourses[index] = {
      ...currentCourses[index],
      ...row,
      modal: row.modal
    };


    handleCourses(currentCourses);

  };

  useEffect(() => {
    updateSemester(semesterName, _courses);
  }, [_courses]);

  useEffect(() => {
    setCourses(courses?.length > 0 ? courses : []);
  }, []);

  const columns = [
    ...TableCol(handleSave, status)
  ];

  return courses ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={_courses.filter(row => row.apa?.id !== 'apa_point')}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={columns.length - 1} align='right' >
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell colSpan={1}>{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />

    </>
  ) : (
    <></>
  );
};
